var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-item',{attrs:{"label":_vm.$t('system.text_210'),"extra":_vm.$t('system.text_211')}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:(_vm.decorators.cas_server_url),expression:"decorators.cas_server_url"}]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }